/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListSyndigoCategoriesQueryResponse,
  ListSyndigoCategoriesQueryParams,
} from '../types/ListSyndigoCategories'

function getListSyndigoCategoriesUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/products/catalog/variants/syndigo/categories/` as const,
  }
  return res
}

/**
 * @description Get distinct Syndigo categories for the company.
 * GET /catalog/variants/syndigo/categories/
 * Returns:
 * Response with list of distinct categories sorted alphabetically.
 * Each item has 'label' and 'value' keys for frontend compatibility.
 * @summary List distinct Syndigo categories
 * {@link /api/v1/products/catalog/variants/syndigo/categories/}
 */
export async function listSyndigoCategories(
  params?: ListSyndigoCategoriesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListSyndigoCategoriesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListSyndigoCategoriesUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
